import type { Scale2d } from "@logic/lib/2d"
import { studioToScreen } from "@logic/lib/design"

import type { TransactionOperation } from "."
import { getPanelFootprint } from "./getPanelFootprint"
import { zoomState } from "../../view"

export const getOnscreenPanelFootprint: TransactionOperation<
  undefined,
  Scale2d
> = (transactors) =>
  studioToScreen.scale(
    getPanelFootprint(transactors, null),
    transactors.get(zoomState),
  )
